import React from "react";

import CommonCard from "../CommonCard/index";
const LollipopRange = ({ products, title }) => {
  return (
    <>
      <CommonCard
        products={products}
        title={title}
      />
    </>
  );
};

export default LollipopRange;